<mat-sidenav-container  *ngIf="userValidation$ | async as userValidation">
  <mat-sidenav #rightSidenav mode="over" [fixedInViewport]="true" [fixedTopGap]=1 position="end">
    <div class="toolbarspacer"></div>
    <div class="closeMenu"><mat-icon (click)="rightSidenav.toggle()">arrow_back</mat-icon></div>
    <em-side-nav-content [name]="'sideMenu'"></em-side-nav-content>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-container *ngIf="this.shareOption$ | async as shareOption">
      <div class="flexGroup">
        <div *ngIf="shareOption === 'edit'" class="cardSelection" data-tour="step1">
          <div class="toolbarspacer"></div>
          <div class="itemAligner">
            <form [formGroup]="searchForm" data-tour="step2">
              <input formControlName="search" placeholder="Suche nach Titel" />
            </form>

            <mat-tab-group mat-align-tabs="center" animationDuration="250ms">
              <ng-container *ngFor="let cardDeck of userValidation.carddecks">
                <ng-container *ngIf="cardDeck.type === 'pattern'||cardDeck.type === 'causes'">
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <mat-icon class="tabIcon" *ngIf="cardDeck.type === 'causes'" data-tour="step3">electric_bolt</mat-icon>
                      <mat-icon class="tabIcon" *ngIf="cardDeck.type === 'pattern'">hexagon</mat-icon>
                    </ng-template>
                    <ng-container *ngIf="userValidation$ && cardDeck.type === 'pattern'">
                      <em-attribution-request [userValidation$]="userValidation$"></em-attribution-request>
                    </ng-container>
                      <em-default-decks [rightSidenav]="rightSidenav" [searchForm]="searchForm" [cardDeckIdSelection]="cardDeck.id" [deckType]="cardDeck.type" (deleteSearchResults)="resetSearchForm()"></em-default-decks>
                  </mat-tab>
                </ng-container>
              </ng-container>
            </mat-tab-group>
          </div>
        </div>
        <div class="buildingCanvas" [ngClass]="{'width-80': shareOption === 'edit', 'width-100': shareOption !== 'edit'}">
          <div class="toolbarspacer"></div>
          <div class="preview-wrapper">
            <em-card-pattern-preview></em-card-pattern-preview>
          </div>
          <em-svg-viewer [rightSidenav]="rightSidenav"></em-svg-viewer>
        </div>
      </div>
    </ng-container>
  </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #loading>
  <div style="font-size: 90px">LOADINNNG</div>
</ng-template>
